import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';

import { AppsListTabFilterComponent } from './templates-list-tab-filter/apps-list-tab-filter.component';
import { TemplatesListTabFilterItemComponent } from './templates-list-tab-filter-item/templates-list-tab-filter-item.component';
import { TemplatesUsedInLinksWarningComponent } from './templates-used-in-links-warning/templates-used-in-links-warning.component';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, DragDropModule],
  declarations: [
    AppsListTabFilterComponent,
    TemplatesListTabFilterItemComponent,
    TemplatesUsedInLinksWarningComponent,
  ],
  exports: [AppsListTabFilterComponent],
})
export class TemplatesListModule {}
